import { Outlet } from "react-router-dom";

export default function VIP() {
  return <Outlet />;
}
